import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";
import { ReduxStateType } from "redux-store/types";

const authorizationDocumentSelector = (state: RootState) =>
  state.authorizationDocument;

const formSearchADSelector = createSelector(
  authorizationDocumentSelector,
  (state) => state.fromSearchAuthorizationDocumentSlice
);

export const formSearchADSelectorDataSelector = createSelector(
  formSearchADSelector,
  (state) => state.formData
);

export const searchADStateDataSelector = createSelector(
  formSearchADSelector,
  (state) => state.isSearching
);

// get menu
const menuADSelector = createSelector(
  authorizationDocumentSelector,
  (state) => state.menuAuthorizationDocumentSlice
);

const menuItemADSelector = createSelector(
  menuADSelector,
  (state) => state.menuData
);

export const menuItemADDataSelector = createSelector(
  menuItemADSelector,
  (state) => state.data
);

export const menuItemADStatusSelector = createSelector(
  menuItemADSelector,
  (state) => state.status
);

const subMenuItemADSelector = createSelector(
  menuADSelector,
  (state) => state.subMenuData
);

const subMenuCollapseADSelector = createSelector(
  menuADSelector,
  (state) => state.subMenuCollapse
);

export const subMenuItemADDataSelector = (id: string) =>
  createSelector(subMenuItemADSelector, (state) => state[id]?.data);

export const subMenuCollapseADDataSelector = (id: string) =>
  createSelector(
    subMenuCollapseADSelector,
    (state) => state[id]?.isOpen ?? true
  );

export const subMenuItemADStatusSelector = (id: string) =>
  createSelector(
    subMenuItemADSelector,
    (state) => state[id].status || ReduxStateType.INIT
  );

export const subMenuItemADIsOpenSelector = (id: string) =>
  createSelector(subMenuItemADSelector, (state) => state[id]?.isOpen || false);

// get detail
const detailADSelector = createSelector(
  authorizationDocumentSelector,
  (state) => state.getDetailSlice
);

export const detailADDataSelector = createSelector(
  detailADSelector,
  (state) => state.data
);

export const detailADStatusSelector = createSelector(
  detailADSelector,
  (state) => state.status
);

// get list

const listAuthorizationDocumentSelector = createSelector(
  authorizationDocumentSelector,
  (state) => state.getListAuthorizationDocsSlice
);

export const listAuthorizationDocumentByTypeSelector = (type: string) =>
  createSelector(listAuthorizationDocumentSelector, (state) =>
    state[type] ? state[type]?.data : []
  );

export const listAuthorizationDocumentTotalRecordByTypeSelector = (
  type: string
) =>
  createSelector(listAuthorizationDocumentSelector, (state) =>
    state[type] ? state[type]?.totalRecords : 0
  );

export const listAuthorizationDocumentCategoryNameByTypeSelector = (
  type: string
) =>
  createSelector(listAuthorizationDocumentSelector, (state) =>
    state[type] ? state[type]?.categoryName : ""
  );

export const listAuthorizationDocumentsStatusByTypeSelector = (type: string) =>
  createSelector(listAuthorizationDocumentSelector, (state) =>
    state[type] ? state[type]?.status : ReduxStateType.INIT
  );

export const relatedDocumentContentSelector = createSelector(
  detailADSelector,
  (state) => state.relatedDocumentContent
);
